import { render, staticRenderFns } from "./customers-list.vue?vue&type=template&id=7dd65747&scoped=true&"
import script from "./customers-list.vue?vue&type=script&lang=js&"
export * from "./customers-list.vue?vue&type=script&lang=js&"
import style0 from "./customers-list.vue?vue&type=style&index=0&id=7dd65747&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd65747",
  null
  
)

export default component.exports